import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { useTrackingEnabled } from '@/hooks/use-tracking-enabled';
import { openPlatformSettings } from '@/utils/open-platform-settings';

import { CustomSwitch } from './CustomSwitch';

export const AppTrackingAdvertisingSwitch = (): ReactElement | null => {
    const { t } = useTranslation(['account', 'common']);
    const { showInfoSheet } = useAlerts();

    const { isLoading, isEnabled } = useTrackingEnabled();

    const handleTargetedAdvertisingToggle = () => {
        showInfoSheet({
            title: t('targeted_advertising'),
            description: t('targeted_advertising_subtext'),
            buttonLabel: t('common:go_to_settings'),
            handlePress: () => openPlatformSettings(),
        });
    };

    if (isLoading) {
        return null;
    }

    return <CustomSwitch val={isEnabled} handleOnPress={handleTargetedAdvertisingToggle} />;
};
